import './RollingMeter.css'

function RollingMeter({ value = '', label, suffix, size = 'md' }) {
  const chars = String(value)

  return (
    <div className={`rolling-meter rolling-meter--${size}`}>
      {label && <span className="rolling-meter__label">{label}</span>}
      <div className="rolling-meter__face" aria-label={`${label || ''} ${value} ${suffix || ''}`.trim()}>
        {chars.split('').map((ch, index) => (
          ch >= '0' && ch <= '9' ? (
            <span className="rolling-meter__wheel" key={`${index}-${chars.length}`}>
              <span
                className="rolling-meter__strip"
                style={{ transform: `translateY(-${Number(ch)}em)` }}
              >
                {Array.from({ length: 10 }, (_, digit) => (
                  <span key={digit}>{digit}</span>
                ))}
              </span>
            </span>
          ) : (
            <span className="rolling-meter__sep" key={`${index}-${ch}`}>{ch}</span>
          )
        ))}
        {suffix && <span className="rolling-meter__suffix">{suffix}</span>}
      </div>
    </div>
  )
}

export default RollingMeter
